import { render, staticRenderFns } from "./BiodivInformation.vue?vue&type=template&id=0584a2d5"
import script from "./BiodivInformation.vue?vue&type=script&lang=js"
export * from "./BiodivInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports